import baseAPI from '@/api/base';
import { EditJobPost, GetJobPost, RegisterJobPost } from '@/dtos/job_post';
import {
  DELETE_JOB_POST_URL,
  EDIT_JOB_POST_URL,
  GET_JOB_POST_URL,
  REGISTER_JOB_POST_URL,
  TOGGLE_JOB_POST_IS_ACTIVE_URL,
} from '@/utils/urls';
import { AxiosResponse } from 'axios';

class JobPost {
  static getJobPosts = async (getJobPost: GetJobPost): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_JOB_POST_URL, {
      params: getJobPost,
    });
    console.log('response', response);
    return response;
  };

  static registerJobPost = async (
    registerJobPost: RegisterJobPost
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(REGISTER_JOB_POST_URL, {
      ...registerJobPost,
    });
    console.log('response', response);
    return response;
  };

  static editJobPost = async (editJobPost: EditJobPost): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.put(EDIT_JOB_POST_URL, {
      ...editJobPost,
    });
    return response;
  };

  static toggleJobPostIsActive = async (
    editJobPost: { id: string }
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.patch(
      TOGGLE_JOB_POST_IS_ACTIVE_URL,
      {
        ...editJobPost,
      }
    );
    return response;
  };

  static deleteJobPost = async (userId: string): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.delete(
      `${DELETE_JOB_POST_URL}/${userId}`
    );
    return response;
  };
}

export default JobPost;
